import styled from "styled-components";

export const AlertModalStyleWrapper = styled.div`
.alert-modal-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    img{
      margin-bottom: 12px
    }
    h3{
      line-height: 32px
      margin-bottom: 4px
    }
    p {
    font-size: 16px;
    text-align: center;
    color: #22413C;
}
}
`;

export const ShippingWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    grid-gap: 8px;
    grid-gap: 16px;
    &.step1 {
    flex-direction: column;
    .ant-spin-nested-loading{
      width: 100%;
    }
}
.step-content {
margin-top: 20px;
/* height: 76vh */
}

.buttons-wrapper{
  /* margin-top: 32px; check if this reflects in other page as well */
    margin-top: 24px;
  /* display: flex;
  justify-content: end;
  grid-gap: 16px; */

    &.buttons-wrapper--step2 {
    display: flex;
    justify-content: flex-end;
    grid-gap: 16px;
    position: fixed;
    right: 26px;
    bottom: 11px;
    justify-content: inline
  }

.buttons-wrapper-step3{
  display: flex;
  justify-content: end;
}

.final-record-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: end;
    .items-wrapper {
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 16px 12px !important;
    width: calc(100% - 23px);
    p.title-text{
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #535E63;
    margin: 0;
    margin-bottom: 8px;
    }
    .content-items-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
      margin-top: 4px;
    p {
    margin: 0px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: right;
    color: #535E63;
    font-weight: 400;
    &:not(:first-child){
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: right;
    color: #535E63;
    }
}
&.final-record{
  p{
font-weight: 700;
font-size: 16px;
line-height: 16px;
letter-spacing: 0%;
color: #1F1F1F;
&:not(:first-child){
  font-weight: 600;
}
  }
}
}
.ant-divider.ant-divider-horizontal {
    margin: 8px 0px 4px;
}
}
}

}

.global-view-card {
    padding: 8px;
    border: 2px solid #BEC7CB;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    cursor: pointer;
    &.active{
      border-color: #1565D8;
    }
    .title {
    color: #535E63;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    vertical-align: middle;
    border-bottom: 1px solid #BEC7CB;
    padding-bottom: 8px;
}
.tabs-cards-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    grid-gap: 4px;
    margin-bottom: 12px;
    margin-top: 8px;
    p{
      color: #4E5969;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      vertical-align: middle;
      margin: 0px;
      &:not(:last-child) {
      color: #1565D8;
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
}
    }
}
}
.overlay-container{
  display: flex;
  flex-direction: column;
  grid-row-gap: 12px;
  width: 100%;
  max-width: 331px;
  .btn-wrapper {
    width: 191px;
    margin: auto;
    border: 1px solid #D95040;
    background: #fff;
    color: #D95040;
    box-shadow: none;
}
}
    .product-item-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 10px;
    img {
    width: 40px;
    height: 28px;
    object-fit: contain;
}
.product-item {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
}
.ag-cell{
  &:not(:first-child){
    border-left:1px solid #ECEFF1;
  }
}
footer{
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 24px;
  grid-gap: 16px;
}
.overlay-container-custom{
  display: flex;
  width: 100%;
  max-width: 230px;
  flex-direction: column;
}
.cards-overlay-wrapper{
  background-color: #fff;
  border: 1px solid #ECEFF1;
  border-radius: 4px;
  padding: 8px;
  min-height: 150px;
  height: auto;
  max-height: calc(100vh - 85px);
  overflow: auto;
  max-width: 230px;
  width: 100%;
}
.content-area-wrapper {
    width: calc(100% - 230px);
.tabs-cards-wrapper {
    background: #E6F4FC;
    padding: 14px 12px;
    border-radius: 4px;
    width: 100%;
    display: flex;
    overflow: auto;
    grid-gap: 12px;
    margin-bottom: 9px;
    &::-webkit-scrollbar {
      display: none;
    }
    .tab-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 2fr;
    min-width: 218px;
    width: 100%;
    background: #F5FBFF;
    padding: 12px;
    border-radius: 4px;
    border:1px solid transparent;
    cursor: pointer;
    &.active{
      background: #fff;
      border-color: #1565D8;

    }
    .tab-item {
        display: flex;
        flex-direction: column;
        grid-row-gap: 2px;
        p {
        margin: 0px;
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0%;
        color: #808183;
        &:not(:first-child){
          font-weight: 600;
          color: #535E63;
          
        }
}
    }
}
}
}
`

export const StepTwoWrapper = styled.div`
display: flex;
justify-content: space-between;
grid-gap: 12px;
width: 100%;
.postion-relative.search-ui-wrapper {
    min-width: 300px;
}
.items{
  border: 1px solid #ECEFF1;
  padding: 16px 12px 10px;
  border-radius: 4px;
  width: calc(100% - 30%);
  header{
    display: flex;
    justify-content: center;
    margin-bottom: 14px;
    align-items: center;
    p{
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    margin: 0;
    color: #212A2F;
    }
    .actions {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    img {
    width: 30px;
    cursor: pointer;
}
}
  }
  .ant-tabs-tab-active.ant-tabs-tab {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #1565D8;
}
.ant-tabs-ink-bar.ant-tabs-ink-bar-animated{
  background: #1565D8;
  width: 124px;
}
.ant-tabs-tab {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #535E63;
    text-align: center;
}
}

`;
export const StepTwoCard = styled.div`
header{
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #F8FAFB;
  padding: 4px 12px;
    p{
      font-weight: 600;
      font-size: 10px;
      line-height: 12px;
      color: #22413C;
      vertical-align: middle;
      margin: 0px;
    }
}
.title-info-ui-wrap {
    display: flex;
    grid-gap: 16px;
}
.items-ui-view-wrapper {
  min-width: 120px;
  max-width: 300px;
  padding-bottom: 8px;
  .items-ui-view-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 4px 12px;
    p {
    color: #4E5969;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    vertical-align: middle;
    margin: 0px;
}
}
}
.tab-cards-overlay-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
    height: calc(100vh - 321px);
    overflow: auto;
    p.text-items-wrapper-link {
    font-weight: 600;
    font-size: 8px;
    line-height: 12px;
    text-decoration: underline;
    text-decoration-style: solid;
    color: #1565D8 !important;
    cursor: pointer;
}
.tab-cards-item-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px;
    background: #FFFFFF;
    border: 1px solid #ECEFF1;
    border-radius: 4px;
    &.boxed-item {
      background: #DBFFDD;
    }
    .title {
    display: flex;
    align-items: flex-start;
    grid-gap: 16px;
    img{
      width: 36px;
      height: 36px;
      object-fit: contain;
    }
    .heading {
    display: flex;
    flex-direction: column;
    p {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #535E63;
    max-width: 291px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0;
    margin-bottom: 4px;
}
.title-items {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    flex-wrap: wrap;
    padding-right: 8px;
    .card-items {
    display: flex;
    align-items: center;
    position: relative;
    &:nth-child(n+4){
      &::after{
      display: none;
    }
    }
    &::after {
    content: "";
    position: absolute;
    width: 1px;
    background: #ECEFF1;
    height: 100%;
    right: -9px;
}
    p{
      margin: 0;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      color: #808183;
      &:not(:first-child){
        font-weight: 600;
        color: #4E5969;
      }
    }
}
}
}
}
.actions {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    img {
    width: 35px;
    cursor: pointer;
}
}
}
}
`;
export const CollapseAbleCardWrapper = styled.div`
    width: calc(100% - 71%);
`;

export const AccordionCardsDataWrapper = styled.div`
padding: 12px;
margin: 0px;
button{
  margin-left: auto;
  margin-bottom: 12px;
}
.cards-wrapper {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    grid-row-gap: 8px;
    height: calc(100vh - 317px);
    overflow: auto;
    @media (max-width: 1920px) {
      height: calc(100vh - 300px);
    }
  .cards-items{
    display: flex;
    flex-direction: column;
    padding: 10px 12px 8px;
    border: 1px solid #ECEFF1;
    border-radius: 4px;
    grid-row-gap: 8px;
    .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    margin: 0;
    color: #535E63;
}
.actions {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    img{
      width: 30px;
      cursor: pointer;
    }
}
}
.title-items {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    .card-items {
    display: flex;
    align-items: center;
    position: relative;
    &:nth-child(n+3){
      &::after{
      display: none;
    }
    }
    &::after {
    content: "";
    position: absolute;
    width: 1px;
    background: #ECEFF1;
    height: 100%;
    right: -9px;
}
    p{
      margin: 0;
      font-size: 10px;
      line-height: 12px;
      font-weight: 400;
      color: #808183;
      &:not(:first-child){
        font-weight: 600;
        color: #4E5969;
      }
    }
}
.items-action-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 2px;
    img{
      cursor: pointer;
    }
    p{
      margin: 0;
      font-size: 10px;
      line-height: 12px;
      font-weight: 600;
      color: #4E5969;
    }
}
}
    }
}

.empty-box{
    width: inherit;
    height: inherit;
    display: flex;
    justify-content: space-around;
    align-items: center
  }


`;

export const DrawerStyleWrapper = styled.div`
.product-info-ui-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 24px;
}

.product-info-ui-wrapper > img {
  border: 1px solid #D9D9D9;
  min-height: 563px;
  max-width: 368px;
  min-width: 368px;
  max-height: 500px;
  object-fit: contain;
  border-radius: 10px;
  padding: 12px;
}
  .units-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 2fr;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 20px;
.units-items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    p{
      &:not(:first-child) {
    font-size: 16px !important;
    color: #808183 !important;
    line-height: 20px;
}
    }
}
.units-items2 {
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    p{
      &:not(:first-child) {
    font-size: 16px !important;
    color: red !important;
    line-height: 20px;
}
    }
}
}
.fnsku-label-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .enter-qty-field {
    margin-bottom: 0 !important;
  }

  margin-bottom: 12px

}
header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  button{
    margin: 0;
  }
  .title-wrapper {
      display: flex;
      align-items: center;
      grid-gap: 7px;
      img{
        cursor: pointer;
      }
      p {
      margin: 0;
      font-weight: 700;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: 0%;
      color: #1565D8;
  }
  }
}
.product-info-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 16px;
    padding-bottom: 16px;
    img {
    max-width: 220px;
    border-radius: 12px;
    object-fit: contain;
    height: 177px;
    width: 100%;
  }
  .title {
    display: flex;
    flex-direction: column;
    p {
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #4E5969;
    margin: 0px;
    }
    .title-item {
      display: flex;
      align-items: end;
      p {
      font-weight: 400;
      font-size: 18px;
      line-height: 18px;
      letter-spacing: 0%;
      color: #1565D8;
      display: -webkit-box;
      max-width: 100%;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img {
    width: 80px;
    height: fit-content;
    border-radius: 0px;
}
}
.instruction-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 66px;
    .instruction-items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 6px;
    width: 100%;
    p{
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #4E5969;
      &:not(:first-child){
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0%;
      color: #808183;
      }
    }
}

.instruction-items2 {
    display: flex;
    flex-direction: column;
    grid-row-gap: 6px;
    width: 100%;
    p{
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #4E5969;
      &:not(:first-child){
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0%;
      color:rgb(245, 13, 13);
      }
    }
}
}
}
}
.box-info-overlay-wrapper {
    .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;
    .title-item{
      display: flex;
      align-items: center;
      grid-gap: 4px;
    }
    p {
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0%;
    color: #1565D8;
      margin: 0 !important;
    &:not(:first-child) {
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
      letter-spacing: 0%;
      color: #808183;
    }
}
}
.input-boxes-overlay-wrapper {
    height: auto;
    max-height: 160px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
.input-boxes-wrapper {
    display: grid;
    grid-template-columns: 3fr 3fr 1fr;
    grid-gap: 12px;
    align-items: end;
    label{
      font-weight: 600;
      color: #4E5969 !important;
    }
    &.increased{
      grid-template-columns: 3fr 3fr 2fr 1fr;
    }
    div{
      margin: 0;
    }
    .date-picker-items {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    grid-row-gap: 6px;
    img{
      cursor: pointer;
    }
    label{
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0px;
      color: #7E8A90;
    }
    input{
      height: 40px;
      border-radius: 6px;
    }
    img{
      margin: auto;
      margin-block: 0px;
    }
  }
}
}
.select-shipment-wrapper {
  margin-bottom: 24px;
  .title-wrap {
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    color: #1565D8;
    margin: 0;
}

.shipment-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-height: 200px;
    overflow: auto;
    min-height:55px;
    height: 100%;
    align-items: center;
    grid-gap: 8px;
    overflow-x: auto;
    padding-right: 8px;
    &::-webkit-scrollbar {
    width: 3px;
    height: 6px;
}

&::-webkit-scrollbar-track {
    background: #f5f5f5;
}

&::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}
.shipment-card {
    display: flex;
    justify-content: space-between;
    grid-gap: 16px;
    border: 1px solid #E0E0E0;
    background: #F8FAFB;
    padding: 12px;
    border-radius: 4px;
    min-width: fit-content;
    cursor: pointer;
    &.active{
  background-color: #1565D8;
  p {
    color: #F9F9F9 !important;
    &:not(:last-child) {
      color: #FFFFFF;
    }
  }
    }
    .items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #808183;
    &:not(:last-child) {
    font-weight: 600;
}
}
}
}
}
}
}
.label-print-wrapper{
  margin-top: 24px;
  .title {
    &.label-title{
      justify-content: flex-start;
      grid-gap: 3px;
    }
    p {
    margin: 0px;
}
  }
.labels-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    margin: 8px 0px 24px;
    p {
      border: 1px solid #D9D9D9;
      padding: 4px 6px;
      border-radius: 4px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: #535E63;
      margin: 0;
    }
}
}
.buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: end;
    grid-gap: 12px;
}
`

export const CreateMultiSKUBoxWrapper = styled.div`
header{
  display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ECEFF1;
    padding-bottom: 56px;
    .items-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    img{
      cursor: pointer;
    }
    p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    margin: 0px;
    color: #1A1919;
}
}
div{
  margin: 0;
}
  span.input-overlay-wrapper {
    position: relative;
    width: 300px;
    display: block;
    input {
      padding-right: 40px !important;
    }
    span.icon-wrapper {
      position: absolute;
      top: 10px;
      right: 12px;
    }
  }
}
.title-ui-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    img {
      min-width: 32px;
      width: 32px;
      object-fit:contain;
      height: 32px;
    }
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #535E63;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}
}
.input-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    div {
    margin: 0px;
    width: 100%;
}
} 
.date-wrapper{
  .ant-calendar-picker {
    width: 100%;
     i {
    color: #1565D8;
    cursor: pointer;
}
}
}
.ag-cell{
  &:not(:first-child) {
    border-left: 1px solid #e6e6e6 !important;
}
}
.items-data-wrapper {
    margin-top: 16px;
    border: 1px solid #ECEFF1;
    padding: 16px;
    border-radius: 4px;
    .QB-dataTable.multi-sku-fixed-height {
      height: calc(100vh - 524px + 49px) !important;
    }
    p.title {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #535E63;
    margin-bottom: 24px;
}
input{
  height: 30px;
  border-radius: 5px;
}
}
.add-dimension-container {
    display: flex;
    flex-direction: column;
    border: 1px solid #ECEFF1;
    border-radius: 4px;
    padding: 16px;
    margin-top: 24px;
    p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #212A2F;
}
}
span.dimension-input {
    position: relative;
    .icon-wrapper {
    position: absolute;
    top: 33px;
    right: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #BEC7CB;
}
input {
    padding-right: 52px;
}
}
.items-wrapper {
    display: flex;
    align-items: unset;
    grid-gap: 16px;
    & > div:nth-child(1) {
    margin: 0px;
    max-width: 262px;
    width: 100%;
}
}
button{
  margin: 0px;
  margin-top: 24px;
  margin-left: auto;
}
`;
export const BoxDetailsInfoWrapper = styled.div`
header{
  display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ECEFF1;
    padding-bottom: 16px;
    margin-bottom: 16px;
    .items-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    img{
      cursor: pointer;
    }
    p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    margin: 0px;
    color: #1A1919;
}
}
div{
  margin: 0;
}
  span.input-overlay-wrapper {
    position: relative;
    width: 300px;
    display: block;
    input {
      padding-right: 40px !important;
    }
    span.icon-wrapper {
      position: absolute;
      top: 10px;
      right: 12px;
    }
  }
}
.title-ui-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #535E63;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}
}
.input-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 12px;
    height: 100%;
    img{
      cursor: pointer;
      width: 24px;
    }
} 
.date-wrapper{
  .ant-calendar-picker {
    width: 100%;
     i {
    color: #1565D8;
    cursor: pointer;
}
}
}
.ag-cell{
  &:not(:first-child) {
    border-left: 1px solid #e6e6e6 !important;
}
}
.items-data-wrapper {
    margin-top: 16px;
    border: 1px solid #ECEFF1;
    padding: 16px;
    border-radius: 4px;
    p.title {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #535E63;
    margin-bottom: 24px;
}
input{
  height: 30px;
  border-radius: 5px;
}
}
.add-dimension-container {
    display: flex;
    flex-direction: column;
    border: 1px solid #ECEFF1;
    border-radius: 4px;
    padding: 16px;
    margin-top: 24px;
    p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #212A2F;
}
}
span.dimension-input {
    position: relative;
    .icon-wrapper {
    position: absolute;
    top: 33px;
    right: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #BEC7CB;
}
input {
    padding-right: 52px;
}
}
.items-wrapper {
    display: flex;
    align-items: unset;
    grid-gap: 16px;
    & > div:nth-child(1) {
    margin: 0px;
    max-width: 262px;
    width: 100%;
}
}
button{
  margin: 0px;
  margin-top: 24px;
  margin-left: auto;
}
`;

export const EditModalStyleWrapper = styled.div`
padding:12px;
p{
font-weight: 700;
font-size: 18px;
line-height: 30px;
letter-spacing: 0%;
color: #1565D8;
margin:0;
margin-bottom: 30px;
}
.items-wrapper{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  div{
    margin: 0;
  }
}
`;

export const DeleteModalStyleWrapper = styled.div`
.delete-modal-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    grid-row-gap: 16px;
    margin-top: 32px;
    p {
    font-size: 16px;
    /* font-weight: 600; */
    color: #22413C;
    }
    .modal-body{
      text-align: center;

      .info-section{
        display: flex;
        align-items: flex-start;
        gap: 6px;
        p{
          font-size: 12px !important;
          font-weight: 600 !important;
          color: grey !important 
        }
      }
    }
}
`;

export const ContactInformationWrapper = styled.div`
.step-content {
    margin-top: 24px;
}

.buttons-wrapper {
    display: flex;
    justify-content: end;
    margin-top: 24px;
}
.grid-items-header-info-child-info {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    p {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    margin: 0;
    span {
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    color: #808183;
    &:not(:first-child) {
    color: #22413C;
}
}
}
}
.items-info-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px;
    align-items: end;
    .info-inputs{
      display: flex;
      flex-direction: column;
      grid-row-gap: 12px;
      .date-time {
      display: flex;
      flex-direction: column;
      grid-row-gap: 4px;
      max-width: 180px;
      label {
      color: #7E8A90;
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
}
input {
    height: 38px;
}
}
p{
  font-weight: 600;
  font-size: 16px;
  line-height: 12px;
  letter-spacing: 0%;
  color: #22413C;
  margin: 0;
  }
      
    .info-items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    i.anticon.anticon-calendar.ant-calendar-picker-icon {
    color: #1565d8 !important;
}
div{
   margin: 0px;
}
}
}
}
div#react-select-2-placeholder {
    position: relative;
    top: 0px;
}
.cards-shipment-items-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px;
    margin-top: 24px;
    /* height: calc(100dvh - 400px); */
    max-height: calc(100dvh - 380px);
    overflow: auto;
    &.cards-shipment-items-grid--step2 {
      max-height: calc(100dvh - 295px);
      /* height: calc(100dvh - 475px); */

    }
    &::-webkit-scrollbar{
      display: none;
    }
}
.grid-items-header-info{
  background: #F5FBFF;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;

    .shipment-header-titles{
      display: flex;
      justify-content: space-between;
      align-items: center;

      .shipping-mode {
        margin: 0px;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0%;
        background: #9741E7;
        width: 34px;
        color: #fff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
    }

    }


}
.grid-items {
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    h6 {
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    color: #535E63;
}
.items-ui-wrappers{
  padding: 12px;
}
}
.items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    p {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    color: #22413C;
}
.items-child {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: baseline;
    grid-gap: 12px;
    .select2-container {
    margin: 0px;
    .select2-selection__control.select2-selection__control--is-focused {
    min-height: 36px !important;
    max-height: 36px !important;
}
    .select2-selection__control.css-13cymwt-control{
      max-height: 38px;
      min-height: 36px;
    }
}
}
}
.pallets-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
    margin: 0px;
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    color: #22413C;
}
label.ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    label.ant-checkbox-wrapper span {
    font-weight: 400 !important;
    font-size: 10px !important;
    line-height: 100% !important;
    letter-spacing: 0px !important;
    color: #4E5969 !important;
}
}
}
.items-overlay-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    margin-top: 12px;
    min-height: 50px;
    height: 100%;
    max-height: 150px;
    /* max-height: 200px; */
    overflow: scroll;
    &::-webkit-scrollbar{
      display: none;
    }
.items-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 37px;
    align-items: flex-end;
    grid-gap: 8px;
    div {
    margin: 0px;
    .select2-container {
    margin: 0px;
    .select2-selection__control.select2-selection__control--is-focused {
    min-height: 36px !important;
    max-height: 36px !important;
}
    .select2-selection__control.css-13cymwt-control{
      max-height: 38px !important;
      min-height: 36px !important;
    }
}
}
    .actions-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-row-gap: 4px;
    label {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #7E8A90;
    margin-bottom: 4px;
}
    img{
      cursor: pointer;
    }
}
}
}
.final-text {
    display: flex;
    align-items: center;
    margin-top: 8px;
    p {
    margin: 0px;
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    color: #22413C;
    &:not(:first-child) {
    font-size: 10px;
    font-weight: 400;
    color: #4E5969;
}
}
}
`;

export const StepThreeWrapper = styled.div`
&.show-global {
    /* height: calc(100vh - 320px); */
    overflow: visible;
}
.title-labels-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    .items-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 4px;
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    &.shipping-mode {
    background: #9741E7;
    width: 34px;
    color: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
}
    &:not(:first-child) {
    color: #535E63;
    font-weight: 600;
}
}
}
}
.career-items-wrapper{
  p {
    margin: 0px;
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    color: #22413C;
    margin-top: 16px;
    margin-bottom: 6px;
}
  span.item-text-wrapper{
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    &:not(:first-child){
      padding-left: 4px;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      vertical-align: middle;
    }

  }

  .select2-selection__control{
    min-height: 42px;
    max-height: 42px;
  }
}
.radio-items{
  margin-top: 12px;
  .ant-radio-group.ant-radio-group-outline {
    display: grid;
    grid-template-columns: 1fr 1fr 3fr;
    align-items: flex-start;
    grid-gap: 24px;
    .items-wrapper {
    display: flex;
    align-items: baseline;
}
}
    .non-radio-fields{
      grid-template-columns: 1fr 1fr;
      display: grid;
      align-items: flex-start;
      grid-gap: 26px;
    }
}
.final-record-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: end;
    .items-wrapper {
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 16px 12px !important;
    width: calc(100% - 23px);
    p.title-text{
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #535E63;
    margin: 0;
    margin-bottom: 8px;
    }
    .content-items-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
      margin-top: 4px;
    p {
    margin: 0px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: right;
    color: #535E63;
    font-weight: 400;
    &:not(:first-child){
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: right;
    color: #535E63;
    }
}
&.final-record{
  p{
font-weight: 700;
font-size: 16px;
line-height: 16px;
letter-spacing: 0%;
color: #1F1F1F;
&:not(:first-child){
  font-weight: 600;
}
  }
}
}
.ant-divider.ant-divider-horizontal {
    margin: 8px 0px 4px;
}
}
}
.view-card-global-wrapper {
    display: grid;
    /* grid-template-columns: 1fr 1fr; */
    grid-gap: 24px;
    /* margin-bottom: 24px; */
    padding: 0px 12px;
    .items-wrapper-select {
    width: 100%;
    display: flex;
    flex-direction: column;
    & div {
    margin: 0px !important;
}
    p {
    margin: 0px !important;
    font-weight: 400;
    font-size: 8px !important;
    color: #D95040 !important;
    line-height: 12px !important;
}
}
.view-card-global {
    /* border: 1px solid #E0E0E0;
    border-radius: 4px; */
    h6 {
    background: #F5FBFF;
    font-family: Titillium Web;
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: 0%;
    padding: 10px 12px;
    border-radius: 4px;
}
}
}
.date-range-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 270px;
    label {
    color: #7E8A90;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    padding-bottom: 4px;
}
}
.inner-content{
  /* padding: 0px 12px 12px; */
  .ant-radio-group.ant-radio-group-outline {
    grid-template-columns: 1fr 1fr;
    margin-bottom: 4px;
}
}
`;

export const StepFourWrapper = styled.div`
.show-global {
    max-height: calc(100dvh - 174px);
    overflow: auto;
}
.select-items-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    grid-gap: 16px;
}
.items-wrapper-main {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 16px;
    border: 1px solid #E0E0E0;
    padding: 24px;
    border-radius: 4px;
    .items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    p {
    margin: 0;
    font-family: Titillium Web;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #7E8A90;
    &:not(:first-child) {
    color: #535E63;
    font-weight: 600;
}
}
}
}
.default-billing{
    margin: 0px;
    align-self: end;
}
.select-overlay-wrappers {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    margin-top: 16px;
    margin-bottom: 24px;
    .select-items {
    display: flex;
    align-items: end;
    justify-content: end;
    align-items: end;
    grid-gap: 8px;
    div {
    margin: 0 !important;
}
button {
    margin: 0px;
    align-self: end;
}
}
} 

.final-record-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: end;
    margin-top: 24px;
    .items-wrapper {
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 16px 12px !important;
    p.title-text{
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #535E63;
    margin: 0;
    margin-bottom: 8px;
    }
    .content-items-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
      margin-top: 4px;
    p {
    margin: 0px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: right;
    color: #535E63;
    font-weight: 400;
    &:not(:first-child){
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: right;
    color: #535E63;
    }
}
&.final-record{
  p{
font-weight: 700;
font-size: 16px;
line-height: 16px;
letter-spacing: 0%;
color: #1F1F1F;
&:not(:first-child){
  font-weight: 600;
}
  }
}
}
.ant-divider.ant-divider-horizontal {
    margin: 8px 0px 4px;
}
}
}

.cards-group-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px 24px;
    .cards-group{
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    .items-wrapper-main {
      padding-inline: 12px;
    }
    .select-overlay-wrappers {
    padding-inline: 12px;
    display: flex;
    flex-wrap: wrap;
    .billing-button{
      width: 100%;
      margin: 0px !important;
    }
}
      h6 {
    background: #F5FBFF;
    border-bottom: 1px solid #E0E0E0;
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: 0%;
    padding: 10px 12px;
    border-radius: 4px;
}
    }
}
`;

export const StepFiveWrapper = styled.div`
  height: calc(100dvh - 340px);
  overflow: auto;
.cards-items-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px 24px;
    align-items: flex-start;
.card-item {
    display: flex;
    flex-direction: column;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F5FBFF;
    padding: 12px;
    border-bottom: 1px solid #E0E0E0;
    border-radius: 4px;
    p {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 12px;
    letter-spacing: 0%;
}
}
.items-content {
    display: flex;
    align-items: center;
    padding: 16px 12px 12px;
    grid-gap: 32px;
    .content {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
    color: #7E8A90;
    margin: 0px;
    &:not(:first-child) {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
    color: #535E63;
}
}
}
}
}
}
`;

export const PlacementOptionCardStyleWrapper = styled.div`
    background: #1565D8;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
    padding: 16px 12px;
 header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
    color: #E0E0E0;
    margin: 0;
    span {
    font-weight: 600 !important;
    font-size: 12px;
    line-height: 16px;
    vertical-align: middle;
}
}
}
.items-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .items {
    display: flex;
    flex-direction: column;
    p {
    margin: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #F8FAFB;
    vertical-align: middle;
    &:not(:first-child) {
    font-family: Titillium Web;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #E0E0E0;
    vertical-align: middle;
}
span {
    font-weight: 300;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
}
}
}
}
`;